import { Button, Form, Input, Modal, Space } from "antd";
import axios from "axios";
import React, { useContext } from "react";
import { NotificationInfo, UserInfo } from "../../../context";

const EditCredentials = ({ open, close, data, getMyMerchantInfo }) => {
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);

  // console.log("data", data);

  const handleUpdateCredentialCom = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    axios
      .post("user/merchant/update-credentials", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated credentials successfully.");
          setTimeout(() => {
            close();
            getMyMerchantInfo();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      footer={null}
      width={350}
      centered
    >
      <Form
        layout="vertical"
        name="edit-credentials"
        initialValues={{
          username: data.merchantinfouser.username,
          password: "",
        }}
        onFinish={handleUpdateCredentialCom}
        autoComplete="off"
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Form.Item
            id="username"
            name="username"
            label="Username"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set username" size="large" />
          </Form.Item>

          <Form.Item
            // style={{ marginBottom: "5px" }}
            id="password"
            name="password"
            label="Password"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input.Password
              // prefix={<LockOutlined />}
              placeholder="Set password"
              size="large"
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditCredentials;
